/**
 * @desc 根据平台单号及平台查询订单明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getOrderItemBySpOrderNoAndPlatform.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/oms/getOrderItemBySpOrderNoAndPlatform`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
